<template>
  <div class="query-header">
    <el-row
      :gutter="20"
    >
      <!--      <el-col
        :lg="8"
        :md="8"
        :sm="12"
        :xs="24"
        class="el-col-el"
      >
        <div class="label">{{$t('Home.accountType')}}</div>
        <el-select
          style="width: 100%"
          :placeholder="$t('please_choose')"
          v-model="accountType"
          @change="toQuery"
        >
          <el-option
            v-for="(item,index) in accountTypeList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>-->
      <cent-select
        v-if="centAccountConfig"
        :tabs-type="tabsType"
        @send-type="sendType"
      ></cent-select>
      <el-col
        :lg="8"
        :md="8"
        :sm="12"
        :xs="24"
        class="el-col-el"
      >
        <div class="label">{{$t('transaction_status')}}</div>
        <el-select
          style="width: 100%"
          :placeholder="$t('please_choose')"
          v-model="tradeType"
          clearable
          @change="toQuery"
        >
          <el-option
            v-for="(item,index) in tradeypeList"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "queryHeader",
  props: {
    centAccountConfig: {
    },
  },
  data() {
    return {
      accountType: '',
      accountTypeList: [
        {
          label: this.$t('Myself'),
          value: 1,
        },
        {
          label: this.$t('All_subordinates'),
          value: 2,
        },
      ],
      tradeType: '',
      tradeypeList: [
        {
          label: this.$t('normal'),
          value: 0,
        },
        {
          label: this.$t('User.forbidden'),
          value: 1,
        },
      ],
      tabsType: 'USD'
    }
  },
  methods: {
    toQuery() {
      this.$emit('toQuery');
    },
    sendType(tabsType){
      this.tabsType = tabsType;
      this.toQuery();
    }
  },
}
</script>

<style scoped>

</style>
